import { Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import SimpleSelect from "../../components/selects/simpleSelect";
import { months, stateDofa } from "../../constants/selectData";
import { callActionApiAsync, getDofaYears } from "../../services/apiService";
import ColorIndicator from "./colorIndicator";
import "./styles.css";

const DofaFilters = ({ processId, entityType, control, getValues, setValue, onChange }) => {
  const selectedYear = useWatch({ control, name: "year" });
  const [range, setRange] = useState(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let active = true;
    setRange(null);
    setLoadError(false);
    callActionApiAsync(
      () => getDofaYears(processId, entityType),
      (data) => { if (active) setRange(data); },
      () => { if (active) setLoadError(true); }
    );
    return () => { active = false; };
  }, [processId, entityType]);

  useEffect(() => {
    if (!range || !selectedYear) return;
    const year = Number(getValues("year"));
    if (year < range.firstYear || year > range.currentYear) {
      setValue("year", range.currentYear);
      onChange();
    }
  }, [range, selectedYear, getValues, setValue, onChange]);

  // Durante la carga conserva visible el año seleccionado; no ofrece un rango fijo.
  const yearOptions = (range?.years || (selectedYear ? [Number(selectedYear)] : []))
    .map((year) => ({ value: year, name: String(year) }));

  return (
    <>
      {loadError && <Alert severity="error">No se pudieron cargar los años con registros.</Alert>}
      <div className="dofa-period-toolbar">
        <ColorIndicator type={entityType === "strategy" ? "strategies" : undefined} />
        <form className="dofa-period-filters" onSubmit={(event) => event.preventDefault()}>
          <SimpleSelect name="state" control={control} label="Estado" options={stateDofa}
            onChange={onChange} width="100%" margin="0" />
          <SimpleSelect name="month" control={control} label="Mes" options={months}
            onChange={onChange} width="100%" margin="0" />
          <SimpleSelect name="year" control={control} label="Año" options={yearOptions}
            onChange={onChange} width="100%" margin="0" disabled={!range} />
        </form>
      </div>
    </>
  );
};

export default DofaFilters;
